import { isString } from 'fp-ts/lib/string'

export function experimentKeyIsValid(
  key?: string | null | undefined
): key is string {
  return isString(key) && key !== ''
}
